import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgGlass = (props) => /* @__PURE__ */ _jsx("svg", {
	...props,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	children: /* @__PURE__ */ _jsx("path", {
		d: "M16.4431 16.4438L20.9995 21.0001M18.75 10.875C18.75 15.2242 15.2242 18.75 10.875 18.75C6.52576 18.75 3 15.2242 3 10.875C3 6.52576 6.52576 3 10.875 3C15.2242 3 18.75 6.52576 18.75 10.875Z",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgGlass;
